<template>
  <v-select
      v-model="model"
      :options="formattedOptions"
      :label="'label'"
      :reduce="option => option.value"
      :placeholder="placeholder"
      :clearable="false"
      :searchable="true"
      class="custom-select"
  >
    <!-- 옵션 없음 -->
    <template #no-options>
      <span>항목이 없습니다.</span>
    </template>
  </v-select>
</template>

<script setup>
import {defineProps, defineEmits, computed, watch, ref} from 'vue'

// 전역 등록 안 되어 있으면 로컬 등록도 가능
const emits = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {type: [String, Number, Object], default: ''},
  options: {type: Array, default: () => []},
  placeholder: {type: String, default: '선택하세요'},
})

// 포맷 처리: 문자열 배열 vs 객체 배열 구분
const formattedOptions = computed(() => {
  if (props.options.length && typeof props.options[0] === 'object' && 'value' in props.options[0]) {
    return props.options
  } else {
    return props.options.map(item => ({
      value: item,
      label: item,
    }))
  }
})

// 내부 바인딩용 모델
const model = ref(props.modelValue)

// 부모로 반영
watch(model, val => emits('update:modelValue', val))

// 외부에서 modelValue 바뀌면 내부 반영
watch(() => props.modelValue, val => {
  if (val !== model.value) model.value = val
})
</script>
